import React from 'react';

import PromoMarquee from "./PromoMarquee";
import PlayPickX from "./PlayPickX";
import GlobalConst from "../../constants/GlobalConst";
import PickMoreOrLess from "./PickMoreOrLess";
import CreateYourContest from "./CreateYourContest";
import Testimonials from "./Testimonials";

import './LandingPageView.style.scss';

const LandingPageView = () => {

    return (
        <div className={"LandingPageView"}>
            {GlobalConst.FEATURES.PROMO_MARQUEE && <PromoMarquee />}
            <PlayPickX/>
            <PickMoreOrLess/>
            <CreateYourContest/>
            <Testimonials/>
        </div>
    );
}

export default LandingPageView;